module.exports = __webpack_public_path__ + "img/markus-maier-v4.502a0e19.jpg";